export type BaseConfig = {
  stamps_required: number;
  formatted_minimum_order_value: string;
  formatted_reward_value: string;
};

export enum RewardStatus {
  NEW = 'New',
  LIVE = 'Live',
  ENDED = 'Ended',
}

export type RewardConfig = {
  card_shelf_life: {
    quantity: number;
    duration: 'days' | 'weeks' | 'months';
  };
  credit_lifetime: {
    quantity: number;
    duration: 'days' | 'weeks' | 'months';
  };
  plus: BaseConfig | null;
  payg: BaseConfig;
};

export type Reward = {
  status: RewardStatus;
  config: RewardConfig;
  reward_card_program: {
    program_drn_id: string;
    restaurant_drn_ids: string[];
    created_at: string;
    ended_at: string | null;
  };
};
